import { render } from "./TrackNew.vue?vue&type=template&id=8c8a6c06"
import script from "./TrackNew.vue?vue&type=script&lang=js"
export * from "./TrackNew.vue?vue&type=script&lang=js"
script.render = render

export default script